"use client"

import { useEffect, useRef, useState } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

const clients = [
  { name: "CLINICA OFTALMOLOGICA DE SINCELEJO S.A.S", logo: "/images/oftalmologica.png" },
  { name: "IPS LABORATORIO CLINICO ESPECIALIZADO BIOCARE S.A.S", logo: "/images/biocare.png" },
  { name: "SPAM", logo: "/images/prehospitalarios.png" },
  { name: "Laboratorio VIVIR", logo: "/images/laboratoriovivir.png" },
  { name: "Semillero", logo: "/images/cambiosemillero.png" },
  { name: "Corazon y vida", logo: "/images/corazonvidasas.png" },
  { name: "Terapeutica en casa", logo: "/images/terapeuticaencasa.png" },
  { name: "ABC", logo: "/images/clinicaabc.png" },
  { name: "Ser mujer", logo: "/images/sermujer.png" },
  { name: "biocular", logo: "/images/lilianabuitrago.png" },
  { name: "Hospital San Vicente", logo: "/images/diagnosticoscaribe.png" },
  { name: "Diana", logo: "/images/dianarubiano.png" },
  { name: "Movimiento", logo: "/images/movimiento.png" },
  { name: "Fleming", logo: "/images/fleming.png" },
  { name: "biomed", logo: "/images/biomedsas.png" },
  { name: "Polmunar", logo: "/images/cardiopulmonar.png" },
  { name: "Santa Maria", logo: "/images/logoclinica.png" },
  { name: "tusalud oral", logo: "/images/Tusalud.png" },

]

export function ClientsCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [isPaused, setIsPaused] = useState(false)
 const pauseTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const scrollContainer = scrollRef.current
    if (!scrollContainer) return

    let animationFrameId: number
    let scrollPosition = scrollContainer.scrollLeft
    const scrollSpeed = 0.5

    const animate = () => {
      if (!isPaused) {
        scrollPosition += scrollSpeed
        if (scrollContainer) {
          scrollContainer.scrollLeft = scrollPosition

          if (scrollPosition >= scrollContainer.scrollWidth / 2) {
            scrollPosition = 0
          }
        }
      }
      animationFrameId = requestAnimationFrame(animate)
    }

    animationFrameId = requestAnimationFrame(animate)

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId)
      }
    }
  }, [isPaused])

  const scroll = (direction: "left" | "right") => {
    const scrollContainer = scrollRef.current
    if (!scrollContainer) return

    const scrollAmount = 280
    const targetScroll =
      direction === "left" ? scrollContainer.scrollLeft - scrollAmount : scrollContainer.scrollLeft + scrollAmount

    scrollContainer.scrollTo({
      left: targetScroll,
      behavior: "smooth",
    })

    // Pause auto-scroll and resume after 3 seconds
    setIsPaused(true)
    if (pauseTimeoutRef.current) {
      clearTimeout(pauseTimeoutRef.current)
    }
    pauseTimeoutRef.current = setTimeout(() => {
      setIsPaused(false)
    }, 3000)
  }

  const duplicatedClients = [...clients, ...clients]

  return (
    <section className="relative overflow-hidden border-y border-border/50 bg-muted/30 py-16">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <p className="text-sm font-medium uppercase tracking-wider text-muted-foreground">Confían en nosotros</p>
          <h2 className="mt-2 text-4xl font-bold text-foreground">Instituciones de Salud y Consultorios Ya Confían en <span className="text-[#06A1FF]">Nosotros</span></h2>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 z-20 -translate-y-1/2 rounded-full border border-border/50 bg-background/80 p-2 backdrop-blur-sm transition-all hover:bg-background hover:border-primary/50 hover:shadow-lg"
            aria-label="Anterior"
          >
            <ChevronLeft className="h-6 w-6 text-foreground" />
          </button>

          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 z-20 -translate-y-1/2 rounded-full border border-border/50 bg-background/80 p-2 backdrop-blur-sm transition-all hover:bg-background hover:border-primary/50 hover:shadow-lg"
            aria-label="Siguiente"
          >
            <ChevronRight className="h-6 w-6 text-foreground" />
          </button>

          <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-32 bg-gradient-to-r from-muted/30 to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-32 bg-gradient-to-l from-muted/30 to-transparent" />

          <div
            ref={scrollRef}
            className="flex gap-8 overflow-hidden"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {duplicatedClients.map((client, index) => (
              <div
                key={`${client.name}-${index}`}
                className="group flex min-w-[240px] flex-shrink-0 items-center justify-center rounded-xl border border-border/50 bg-card/50 px-8 py-6 backdrop-blur-sm transition-all duration-300 hover:border-primary/30 hover:bg-card hover:shadow-lg"
              >
                <div className="flex items-center justify-center w-full h-20">
                  <img
                    src={client.logo || "/placeholder.svg"}
                    alt={`Logo de ${client.name}`}
                    className="max-w-full max-h-full object-contain grayscale opacity-60 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
